// require('prismjs/themes/prism-tomorrow.css');

require(`katex/dist/katex.min.css`);
